import { dataProvider } from '../../firebase';
import { ISettings } from '../../types';
import { ParserAlgo } from '../sessions/SpeakerInput/types';

export const SETTINGS_UNIQUE_ENTRY_ID = '1';
const RESOURCE = 'settings';

const DEFAULT_REMOVE_WORDS = [
  'Dra?\\.?',
  'Coordinador(es)?:?',
  'Coordina[^:]*:',
  '\\(.*\\)',
  'Presidente\\s*:?',
  'Secretario\\s*:?',
  'Presentador\\s*:?',
  'Disertante(s)?:?',
  'Lic\\.',
  'Prof\\.?',
  'Coordinaci.n:?',
  'Panelista(s)?:?',
  'Autor(es)?:?',
  'Tallerista(s)?:?',
  'Director(es)?:?',
  'Docente(s)?:?',
  '^.*:',
];

export const initSettings = async () => {
  console.log(`Initializing ${RESOURCE}...`);
  try {
    const exist = (await dataProvider.getOne(RESOURCE, { id: SETTINGS_UNIQUE_ENTRY_ID })).data as ISettings;
    if (exist) {
      return;
    }
  } catch (e) {
    // do nothing: fails because doesnt exist
  }
  const record: ISettings = {
    id: SETTINGS_UNIQUE_ENTRY_ID,
    speakersAutoParser_algo: ParserAlgo.nameLastn,
    speakersAutoParser_speakerSeparator: '-',
    speakersAutoParser_nameSeparator: '@',
    speakersAutoParser_remover: DEFAULT_REMOVE_WORDS.map(w => ({ word: w })),
  };
  await dataProvider.create(RESOURCE, { data: record });

  console.log(`Initializing ${RESOURCE}... done`);
};
